import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { staffApi } from '@/lib/api';

const StaffAuthContext = createContext(null);

export function StaffAuthProvider({ children }) {
  const [staff, setStaff] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem('tiffin_staff_token');
    if (!token) {
      setStaff(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await staffApi.get('/auth/staff/me');
      setStaff(data.staff);
    } catch {
      localStorage.removeItem('tiffin_staff_token');
      setStaff(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await staffApi.post('/auth/staff/login', { email, password });
    localStorage.setItem('tiffin_staff_token', data.token);
    setStaff(data.staff);
    return data.staff;
  };

  const logout = () => {
    localStorage.removeItem('tiffin_staff_token');
    setStaff(null);
  };

  const hasRole = (...roles) => staff && roles.includes(staff.role);

  return (
    <StaffAuthContext.Provider value={{ staff, loading, login, logout, hasRole, refresh: loadMe }}>
      {children}
    </StaffAuthContext.Provider>
  );
}

export const useStaffAuth = () => useContext(StaffAuthContext);
